import getIn from 'transmute/getIn';
export const getSubmittedTranscriptEmailAddress = getIn(['emailAddress']);
export const getSubmittedTranscriptSubject = getIn(['subject']);